import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { TAGS } from './constant';

export default createFetchReducer(TAGS);
